import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { CommercialGuarantorLegalNameRuleset } from '../../business/ruleset/solar_property';

import * as Yup from 'yup';

const {
  formField: { commercialGuarantorLegalName },
} = loanFormModel;

export class CommercialGuarantorLegalNameValidation
  implements ValidationSchema
{
  public name: string = commercialGuarantorLegalName.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = CommercialGuarantorLegalNameRuleset;

  public when(schema: Yup.StringSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required)
      return schema.required(commercialGuarantorLegalName.requiredErrorMsg);

    return schema;
  }
}
export default new Validation(new CommercialGuarantorLegalNameValidation());
